// @ts-nocheck
import React, { useEffect, useState, FunctionComponent } from "react";
import style from "./login.module.scss";
import cls from "classnames";
import { Button } from "../../Components/button";
import { connect } from "react-redux";
import { compose } from "redux";
import { ILoginState } from "./reducer";
import { bindActionCreators } from "redux";
import { TextField, Card } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { withTitle } from "../../HoC";

import { login } from "./actions";
import { getKey, getUserMetadata } from "../../utils/localStorage";
import { translate } from "../../translations/translate";

export interface ILoginActions {
  actions: {
    login: (username, password) => void;
  };
  intl: any;
}

interface IBrowserHistory {
  history: string[];
}

type ILoginProps = IBrowserHistory & ILoginActions & { loginReducer: ILoginState };

export const LoginPage: FunctionComponent<ILoginProps> = (props) => {

  const token = getKey("token");
  const {
    loginReducer: {
      isError,
      isPending,
      errorMessage,
    },
    actions,
  } = props;

  const [ userName, setUser ] = useState("");
  const [ password, setPassword ] = useState("");
  const history = useHistory();

  return (<div className={style["wrapper"]}>
    <Card elevation={4} className={style["card"]}>
      <h1>  {translate("login")} </h1>
      <TextField
        name="userName"
        className={cls(style["text-field"], "text-field")}
        onChange={(ev) => setUser(ev.target.value)}
        label={translate("username")}
        value={userName}
        variant="outlined"
      />
      <TextField
        name="password"
        type="password"
        className={cls(style["text-field"], "text-field")}
        onChange={(ev) => setPassword(ev.target.value)}
        label={translate("password")}
        value={password}
        variant="outlined"
      />
      <p
        className={`${style["info"]} ${isError ? style["visible"] : ""}`}
      >
        {errorMessage}
      </p>
      <Button
        label={translate("login")}
        isActive={!isPending}
        onClick={() => {
          actions.login(userName, password).then((userType: any) => {
            switch (userType) {
              case 0:
                history.push("/admin");
                break;
              case 10:
                history.push("/management");
                break;
              default:
                history.push("/");
                break;
            }
          });
        }}
      />
    </Card>
  </div>);
};

const mapStateToProps = (state: { loginReducer: ILoginState }) => ({
  loginReducer: state.loginReducer,
});

const mapDispatchToProps = (dispatch) =>  ({
  actions : bindActionCreators({
    login,
  }, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTitle(translate("login")),
)(LoginPage);
